import { useSelector } from 'react-redux';
import { routeSelector } from 'store/state/selectors/router';
import { useRoute, DecodedRouteParams } from 'config/routes';
import { useCallback } from 'react';
import { ExpandCollection } from 'store/state/insightsContext';
import { isServer } from 'utils';


export function useInsightExpandUrlCreator(
  collection: ExpandCollection
): (insightId: string) => string {
  if (isServer()) {
    return () => null;
  }
  const route = useSelector(routeSelector);
  const { router } = useRoute();

  return useCallback((id: string) => {

    const params: DecodedRouteParams = {
      ...route.params,
      insightCollection: collection,
      insightId: id,
    };

    return router.buildUrl(route.name, params);
  }, [ route, router, collection ]);
}
